import { HTTP } from './http-common.js';

/**
 * @typedef {number} Role
 * 
 * 
 * @typedef {Object} Actor
 * @property {number} id
 * @property {string} firstName
 * @property {string} lastName
 * @property {string} login
 * @property {Role} role
 */

/** @type {?boolean} */
let loggedIn = null;

/** @type {?Actor} */
let viewer = null;

export default {

  login(username, password, callback) {
    const data = new FormData();
    data.append('username', username);
    data.append('password', password);

    HTTP.post('/login', data)
      .then(response => {
        loggedIn = response.data.data !== null;
        viewer = response.data.data;
        callback(loggedIn, null);
      })
      .catch(e => {
        loggedIn = false;
        viewer = null;
        callback(loggedIn, e);
      });
  },

  isLoggedIn(callback) {
    if(loggedIn !== null) {
      callback(loggedIn, null);
      return;
    }

    HTTP.get('/login_info')
      .then(response => {
        loggedIn = response.data.data !== null;
        viewer = response.data.data;
        callback(loggedIn, null);
      })
      .catch(e => {
        loggedIn = false;
        callback(loggedIn, e);
      });
  },

  logout(callback) {
    HTTP.post('/logout')
      .then(response => {
        if(response.data.success) {
          loggedIn = false;
          viewer = null;
        }
        callback(null);
      })
      .catch(e => {
        callback(e);
      });
  },

  getViewer() {
    return viewer;
  },
};
